<template>
  <div class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="true"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeOptionTodos="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active @click="buscarDadosDaLista()">
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div>
            <div class="filter-table">
              <div class="filter-table-item">
                <div class="input-idade">
                  <label>De</label>
                  <input
                    type="text"
                    v-model="idade_inicial"
                    class="form-control"
                    placeholder="idade"
                  />
                  <label>a</label>
                  <input
                    type="text"
                    v-model="idade_final"
                    class="form-control"
                    placeholder="idade"
                  />
                </div>
              </div>
              <div class="filter-table-item">
                <select
                  name="sexo"
                  @change="onChangeSexo($event)"
                  class="form-control select-sexo"
                  v-model="sexo"
                >
                  <option value="" disabled selected>Sexo</option>
                  <option value="">Todos</option>
                  <option value="M">Masculino</option>
                  <option value="F">Feminino</option>
                </select>
              </div>
            </div>
            <div class="info-table">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                ></Subtitle>
              </div>
              <div class="info-table-item">
                <vue-select
                  :options="groupFilterItems"
                  label="label"
                  placeholder="Grupos"
                  v-model="groupFilter"
                  :clearable="true"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.label }}
                  </template>
                  <div slot="no-options">Não há opções correspondentes</div>
                </vue-select>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="cadastros-cidadaos"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros-vuetfy
              ref="table"
              :cadastros="displayedCadastros"
              :data_secretaria_de_saude="data_secretaria_de_saude"
              :loading="loading"
              texto_esus_pec="Cadastros registrados até"
              :data_esus_pec="data_secretaria_de_saude"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros-vuetfy>
          </div>
        </b-tab>
        <b-tab title="Consolidado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Consolidado
          </template>
          <div class="row">
            <div class="col-md-12">
              <div class="resultado-tabs2">
                <b-tabs
                  id="tabs-2"
                  key="tabs-2"
                  fill
                  class="esus-feedback-tabs"
                  v-model="tabsActive2"
                >
                  <b-tab title="resultado" active>
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Tabela"
                        class="icon-tooltip icofont-table"
                      ></i>
                    </template>
                  </b-tab>
                  <b-tab title="grafico" @click="abrirAbaResultadoGrafico()">
                    <template v-slot:title>
                      <i
                        v-b-tooltip.hover
                        title="Gráfico"
                        class="icon-tooltip icofont-chart-bar-graph"
                      ></i>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
              <div v-if="tabsActive2 === 1">
                <resultado-grafico
                  :cadastros="displayedCadastros"
                  :arrayChartMunicipio="arrayChartMunicipio"
                  :arrayChartEquipe="arrayChartEquipe"
                  :populacaoIbge="parseInt(populacaoIbge)"
                  :populacaoSisab="parseInt(totalCadastrosMunicipio)"
                  :populacaoSisabEquipe="parseInt(totalCadastrosEquipe)"
                  :temEquipe="temEquipe"
                  :temAcs="false"
                  :municipio="_municipio"
                  :equipe="_equipe"
                  :acs="_acs"
                  :minCadEquipe="parseInt(dadosSisabEquipe.min_cad)"
                  :maxCadEquipe="parseInt(dadosSisabEquipe.max_cad)"
                >
                </resultado-grafico>
              </div>
              <div v-if="tabsActive2 === 0">
                <tabela-resultado
                  :labelColunaAtualizados="labelColunaAtualizados"
                  :labelColunaDesatualizados="labelColunaDesatualizados"
                  @onChangeIndicador="onChangeIndicadorResultado"
                  :resetarSelectTabelaResultado="resetarSelectTabelaResultado"
                  :disabledSelectResultado="disabledSelectResultado"
                  :loading="loading"
                  :secretaria_municipal_de_saude_total_no_municipio="
                    secretaria_municipal_de_saude_total_no_municipio
                  "
                  :secretaria_municipal_de_saude_no_municipio_atualizados="
                    secretaria_municipal_de_saude_no_municipio_atualizados
                  "
                  :secretaria_municipal_de_saude_no_municipio_desatualizados="
                    secretaria_municipal_de_saude_no_municipio_desatualizados
                  "
                  :secretaria_municipal_de_saude_total_na_equipe="
                    secretaria_municipal_de_saude_total_na_equipe
                  "
                  :secretaria_municipal_de_saude_na_equipe_atualizados="
                    secretaria_municipal_de_saude_na_equipe_atualizados
                  "
                  :secretaria_municipal_de_saude_na_equipe_desatualizados="
                    secretaria_municipal_de_saude_na_equipe_desatualizados
                  "
                  :secretaria_municipal_de_saude_total_no_acs="
                    secretaria_municipal_de_saude_total_no_acs
                  "
                  :secretaria_municipal_de_saude_no_acs_atualizados="
                    secretaria_municipal_de_saude_no_acs_atualizados
                  "
                  :secretaria_municipal_de_saude_no_acs_desatualizados="
                    secretaria_municipal_de_saude_no_acs_desatualizados
                  "
                  :data_secretaria_de_saude="data_secretaria_de_saude"
                  :selectedIndicador="indicadorResultado"
                >
                </tabela-resultado>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="S. Histórica" @click="buscarDadosDoGrafico()">
          <pulse-loader
            :loading="loadingGrafico"
            :color="color"
            :size="size"
            class="vue-loader"
          ></pulse-loader>
          <template v-slot:title>
            <i class="icofont-chart-histogram"></i> S. Histórica
          </template>
          <div class="row">
            <div class="col-lg-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-chart-bar-graph"></i> Série Histórica
                  </h4>
                  <vue-select
                    name="situacao-cadastro"
                    v-model="indicadorGrafico"
                    class="select-situacao-cadastro"
                    :clearable="true"
                    :options="optionsIndicador"
                    label="label"
                    placeholder="Situação cadastro"
                    @input="onChangeIndicadorGrafico"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.label }}
                    </template>
                    <div slot="no-options">Não há opções correspondentes</div>
                  </vue-select>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-lg-12">
                      <apexchart
                        type="line"
                        height="350"
                        :options="chartOptions"
                        :series="chartData"
                        ref="chartData"
                      ></apexchart>
                      <p class="fonte">
                        <b>Fonte:</b> e-SUS PEC,
                        {{ data_secretaria_de_saude }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Mapa" @click="buscarDadosDoMapa()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Mapa
          </template>
          <component-mapa
            :dadosDoMapaOriginal="dadosDoMapaOriginal"
            :dadosDoMapa="dadosDoMapa"
            :tabelaResultado="tabelaResultado"
            :equipe="equipe"
            :cadastros="displayedCadastros"
            ref="componentMapa"
          />
          <tabela-mapa :dados="dadosDoMapa"></tabela-mapa>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import ResultadoGrafico from './ResultadoGrafico.vue'
import { mapState } from 'vuex'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { chartOptions, dataFields, groupFilterItems } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import Selects from '@/components/utils/Selects.vue'
import TabelaResultado from './TabelaResultado.vue'
import TabelaMapa from './TabelaMapa.vue'
import ComponentMapa from './Mapa.vue'

export default {
  name: 'CadastrosIndividuaisPorEquipeAcs',
  components: {
    Subtitle,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    PulseLoader,
    TabelaCadastrosVuetfy,
    Selects,
    'resultado-grafico': ResultadoGrafico,
    TabelaResultado,
    TabelaMapa,
    ComponentMapa,
  },
  mixins: [utils],
  data() {
    return {
      disabledSelectResultado: false,
      loadingGrafico: false,
      size: '40px',
      color: '#0D98BB',
      tabsActive: 0,
      tabsActive2: 0,
      micro_areas: [],
      micro_area: '',
      select_microarea: '',
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      nomeProfissional: '',
      select_profissional: '',
      visibleDataAcs: false,
      cadastros: [],
      cadastrosOriginais: [],
      page: 1,
      perPage: 30,
      pages: [],
      idade_inicial: '',
      idade_final: '',
      data_ministerio_da_saude: null,
      populacaoIbge: 0,
      totalCadastrosMunicipio: 0,
      totalCadastrosEquipe: '',
      parametro: '',
      diferencaDeCadastros: '',
      diferenca_no_municipio: '',
      resultado_no_municipio: '',
      diferenca_na_equipe: '',
      resultado_na_equipe: '',
      total_de_registros_da_tabela: 0,
      data_secretaria_de_saude: '',
      secretaria_municipal_de_saude_total_no_municipio: 0,
      secretaria_municipal_de_saude_no_municipio_atualizados: 0,
      secretaria_municipal_de_saude_no_municipio_desatualizados: 0,
      secretaria_municipal_de_saude_total_na_equipe: 0,
      secretaria_municipal_de_saude_na_equipe_atualizados: 0,
      secretaria_municipal_de_saude_na_equipe_desatualizados: 0,
      secretaria_municipal_de_saude_total_no_acs: 0,
      secretaria_municipal_de_saude_no_acs_atualizados: 0,
      secretaria_municipal_de_saude_no_acs_desatualizados: 0,
      loading: false,
      secretaria_municipal_de_saude_resultado_no_municipio: 0,
      secretaria_municipal_de_saude_resultado_na_equipe: 0,
      disableBtnSalvarSerie: true,
      arrayChartMunicipio: [],
      arrayChartEquipe: [],
      max_yaxis: 0,
      data_dados_chart: '',
      xaxis: [],
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      sexo: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      tabsActive2: 0,
      temEquipe: false,
      temAcs: false,
      groupFilterItems: [...groupFilterItems],
      groupFilter: { label: 'Ativos', value: 'ativos' },
      filterSearchTable: false,
      equipeEvent: '',
      tabelaResultado: [],
      indicadorResultado: {
        label: 'FCI Atualizada e 100% completa',
        value: '28',
      },
      equipeDataNuIne: '',
      indicadorGrafico: {
        label: 'FCI Atualizada e 100% completa',
        value: '28',
      },
      optionsIndicador: [
        { label: 'FCI Atualizada e >90% completa', value: '29' },
        { label: 'FCI Atualizada e 100% completa', value: '28' },
        { label: 'FCI Atualizada', value: '0' },
        { label: 'FCI Completa', value: '27' },
      ],
      resetarSelectTabelaResultado: false,
      dadosDoMapaOriginal: [],
      labelColunaAtualizados: 'Atualizados e completos',
      labelColunaDesatualizados: 'Desatualizados ou incompletos',
      dadosSerieHistorica: [],
      dadosSisabEquipe: {
        min_cad: 0,
        max_cad: 0,
      },
      tituloGrafico: '',
      checkboxEquipeDadosDoMapa: false,
      disabledCheckboxEquipeDadosDoMapa: true,
    }
  },
  mounted() {},
  computed: {
    _resultadoAcs() {
      return (
        (this.populacaoIbge / this.secretaria_municipal_de_saude_total_no_acs) *
        100
      )
    },
    _municipio() {
      return {
        total: this.secretaria_municipal_de_saude_total_no_municipio,
        atualizados:
          this.secretaria_municipal_de_saude_no_municipio_atualizados,
        desatualizados:
          this.secretaria_municipal_de_saude_no_municipio_desatualizados,
      }
    },
    _equipe() {
      return {
        total: this.secretaria_municipal_de_saude_total_na_equipe,
        atualizados: this.secretaria_municipal_de_saude_na_equipe_atualizados,
        desatualizados:
          this.secretaria_municipal_de_saude_na_equipe_desatualizados,
      }
    },
    _acs() {
      return {
        total: this.secretaria_municipal_de_saude_total_no_acs,
        atualizados: this.secretaria_municipal_de_saude_no_acs_atualizados,
        desatualizados:
          this.secretaria_municipal_de_saude_no_acs_desatualizados,
      }
    },
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.cadastros,
        this.idade_inicial,
        this.idade_final,
        this.sexo,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.data_secretaria_de_saude,
        this.groupFilter
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
    ...mapState(['user']),
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
    dadosDoMapa() {
      if (this.checkboxEquipeDadosDoMapa) {
        if (this.equipe == '') {
          this.$toast.info('Por favor, selecione uma equipe.', '', {
            position: 'topRight',
          })
        }

        return this.dadosDoMapaOriginal.filter((el) => {
          if (this.equipe != '' && this.checkboxEquipeDadosDoMapa) {
            return el.ibge_ine == this.equipe.nu_ine
          }
          return el
        })
      }
      return this.dadosDoMapaOriginal
    },
  },
  methods: {
    abrirAbaResultadoGrafico() {
      this.tabsActive2 === 1
      this.indicadorResultado = {
        label: 'FCI Atualizada e 100% completa',
        value: '28',
      }
      this.onChangeIndicadorResultado(this.indicadorResultado)
    },

    getRadiusMarker(item) {
      return Functions.getRadius(item)
    },

    getRadiusColor(item) {
      return Functions.getRadiusColor(item)
    },

    onChangeIndicadorGrafico(val) {
      if (val == null) {
        this.indicadorGrafico = {
          label: 'FCI Atualizada e 100% completa',
          value: '28',
        }
      }
      switch (val.value) {
        case '28':
          this.tituloGrafico =
            'CADASTRO POPULACIONAL ATUALIZADO E COMPLETO FEITO PELA eSF E/OU eAP'
          break
        case '0':
          this.tituloGrafico =
            'CADASTRO POPULACIONAL ATUALIZADO FEITO PELA eSF E/OU eAP'
          break
        case '27':
          this.tituloGrafico =
            'CADASTRO POPULACIONAL COMPLETO FEITO PELA eSF E/OU eAP'
          break
        default:
          break
      }
      this.buscarDadosDoGrafico()
    },

    async onChangeIndicadorResultado(item) {
      switch (item.value) {
        case '28':
          this.labelColunaAtualizados = 'Atualizados e completos'
          this.labelColunaDesatualizados = 'Desatualizados ou incompletos'
          break
        case '0':
          this.labelColunaAtualizados = 'Atualizados'
          this.labelColunaDesatualizados = 'Desatualizados'
          break
        case '27':
          this.labelColunaAtualizados = 'Completos'
          this.labelColunaDesatualizados = 'Incompletos'
          break
        default:
          break
      }

      this.resetarSelectTabelaResultado = false
      this.indicadorResultado = item
      this.setarResultadoMunicipio()
      this.setarResultadoEquipe()
      this.setarResultadoAcs()
    },

    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.exibirCadastrosVerdes = false
      }
    },

    onChangeSexo(event) {
      this.sexo = event.target.value
    },

    cleanFilters() {
      this.idade_inicial = ''
      this.idade_final = ''
      this.sexo = ''
    },

    async onChangeEquipe(event) {
      this.resetarSelectTabelaResultado = false
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.tabsActive2 = 0
      this.cleanFilters()
      if (event !== null) {
        this.disabledCheckboxEquipeDadosDoMapa = false
        this.disabledSelectResultado = false
        this.equipeEvent = event
        this.temEquipe = true
        this.profissionais = []
        this.profissional = ''
        this.nomeProfissional = ''
        this.select_profissional = ''
        this.micro_area = ''
        this.select_microarea = ''
        this.cadastros = []
        this.equipe = event
        this.cadastrosOriginais = []
        this.disableBtnSalvarSerie = false
        this.secretaria_municipal_de_saude_total_no_acs = 0
        this.secretaria_municipal_de_saude_no_acs_atualizados = 0
        this.secretaria_municipal_de_saude_no_acs_desatualizados = 0
        this.parametro = 0
        this.totalCadastrosEquipe = 0
        this.diferenca_na_equipe = 0
        this.resultado_na_equipe = 0
        this.secretaria_municipal_de_saude_total_na_equipe = 0
        this.secretaria_municipal_de_saude_resultado_na_equipe = 0
        this.secretaria_municipal_de_saude_na_equipe_atualizados = 0
        this.secretaria_municipal_de_saude_na_equipe_desatualizados = 0
        try {
          this.loading = true

          // cadastros por equipe
          this.buscarCadastrosIndividuaisTodosPorEquipe()

          //pega a equipe do acs
          let equipe = await this.$api.get(
            '/app/equipe/' + this.cod_ibge + '/' + this.equipe.nu_ine
          )
          if (equipe) {
            this.nomeEquipe = equipe.data.no_equipe
            this.totalCadastrosEquipe = equipe.data.resultado_atual_cadastro
            this.parametro = equipe.data.parametro_cadastro
            this.diferenca_na_equipe =
              equipe.data.resultado_atual_cadastro -
              equipe.data.parametro_cadastro
            this.resultado_na_equipe =
              (equipe.data.resultado_atual_cadastro /
                equipe.data.parametro_cadastro) *
              100
            // dados da equipe
            this.equipeDataNuIne = equipe.data.nu_ine

            await this.setarResultadoEquipe()
            this.carregarSerieHistoricaPorEquipe(
              equipe.data.nu_ine,
              this.secretaria_municipal_de_saude_resultado_no_municipio,
              this.secretaria_municipal_de_saude_resultado_na_equipe
            )
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.disabledCheckboxEquipeDadosDoMapa = true
        this.resetarSelectTabelaResultado = false
        this.disabledSelectResultado = true
        this.equipeEvent = ''
        this.profissionais = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.profissionais = []
        this.profissional = ''
        this.nomeProfissional = ''
        this.select_profissional = ''
        this.micro_area = ''
        this.select_microarea = ''
        this.equipe = ''
        this.temEquipe = false
      }
    },

    setarResultadoMunicipio() {
      const result = Functions.resultadoDoMunicipio(
        this.indicadorResultado,
        this.tabelaResultado,
        this.parametro
      )
      this.secretaria_municipal_de_saude_total_no_municipio = result.total
      this.secretaria_municipal_de_saude_no_municipio_atualizados =
        result.atualizados
      this.secretaria_municipal_de_saude_no_municipio_desatualizados =
        result.desatualizados
      this.secretaria_municipal_de_saude_resultado_no_municipio =
        result.resultado
      this.carregarSerieHistorica(
        this.secretaria_municipal_de_saude_resultado_no_municipio,
        this.indicadorResultado
      )
    },

    setarResultadoEquipe() {
      const result = Functions.resultadoDaEquipe(
        this.indicadorResultado,
        this.tabelaResultado,
        this.equipeDataNuIne,
        this.parametro
      )
      this.secretaria_municipal_de_saude_total_na_equipe = result.total
      this.secretaria_municipal_de_saude_na_equipe_atualizados =
        result.atualizados
      this.secretaria_municipal_de_saude_na_equipe_desatualizados =
        result.desatualizados
      this.secretaria_municipal_de_saude_resultado_na_equipe = result.resultado

      let responseEquipe = this.tabelaResultado.find((item) => {
        return item.ibge_ine == this.equipe.nu_ine
      })
      if (responseEquipe != undefined) {
        this.dadosSisabEquipe.min_cad = responseEquipe.min_cad
        this.dadosSisabEquipe.max_cad = responseEquipe.max_cad
      }
    },

    async setarResultadoAcs() {
      const result = Functions.resultadoDoAcs(
        this.indicadorResultado,
        this.tabelaResultado,
        this.profissional,
        this.parametro
      )
      this.secretaria_municipal_de_saude_total_no_acs = result.total
      this.secretaria_municipal_de_saude_no_acs_atualizados = result.atualizados
      this.secretaria_municipal_de_saude_no_acs_desatualizados =
        result.desatualizados
      this.secretaria_municipal_de_saude_resultado_no_acs = result.resultado
    },

    onChangeProfissional(event) {
      this.resetarSelectTabelaResultado = false
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.micro_area = ''
      this.tabsActive2 = 0
      this.cleanFilters()
      this.select_microarea = ''
      if (event !== null) {
        this.disabledSelectResultado = false
        this.temAcs = true
        this.profissional = event.nu_cpf
        this.buscarDados(event)
      } else {
        // cadastros por equipe
        this.buscarCadastrosIndividuaisTodosPorEquipe()
        this.temAcs = false
        this.profissional = ''
        this.nomeProfissional = ''
        this.select_profissional = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        if (this.profissional || this.equipe) {
          this.disabledSelectResultado = false
        } else {
          this.resetarSelectTabelaResultado = false
          this.disabledSelectResultado = true
        }
        this.onChangeEquipe(this.equipeEvent)
      }
    },

    async onChangeMicroArea(event) {
      this.resetarSelectTabelaResultado = false
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.secretaria_municipal_de_saude_total_no_acs = 0
      this.secretaria_municipal_de_saude_no_acs_atualizados = 0
      this.secretaria_municipal_de_saude_no_acs_desatualizados = 0
      this.tabsActive = 0
      this.tabsActive2 = 0
      this.profissional = ''
      this.nomeProfissional = ''
      this.cleanFilters()
      this.select_profissional = ''
      if (event !== null) {
        this.situacao = ''
        this.loading = true
        this.micro_area = event?.micro_area
        this.disabledSelectResultado = true
        if (this.micro_area !== undefined) {
          let response = await Functions.getCadastrosIndividuaisPorMicroArea(
            this.cod_ibge,
            this.equipe.nu_ine,
            this.micro_area
          )
          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.total_de_registros_da_tabela = response.length
            this.loading = false
          }
        }
      } else {
        this.resetarSelectTabelaResultado = false
        // cadastros por equipe
        this.buscarCadastrosIndividuaisTodosPorEquipe()
        this.micro_area = ''
        this.select_microarea = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.disabledSelectResultado = false
        this.onChangeEquipe(this.equipeEvent)
      }
    },

    async buscarDadosDaLista() {
      this.cleanFilters()
      if (this.profissional !== '' && this.profissional !== null) {
        this.loading = true
        try {
          const profissional = await this.$api.get(
            '/app/profissional/' + this.profissional + '/' + this.cod_ibge
          )
          let response = await Functions.getCadastrosIndividuais(
            this.cod_ibge,
            profissional.data.nu_cpf
          )
          if (response) {
            this.cadastros = response
            this.total_de_registros_da_tabela = response.length
            this.setRed = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    },

    async buscarDadosDoGrafico() {
      this.loadingGrafico = true
      // título do gráfico
      this.$refs.chartData.updateOptions({
        title: {
          text: this.tituloGrafico,
        },
      })
      await this.carregarSerieHistorica(
        this.secretaria_municipal_de_saude_resultado_no_municipio,
        this.indicadorGrafico
      )
      if (this.equipe !== '') {
        this.nomeEquipe = this.equipe.no_equipe
        await this.carregarSerieHistoricaPorEquipe(
          this.equipe.nu_ine,
          this.secretaria_municipal_de_saude_resultado_no_municipio,
          this.secretaria_municipal_de_saude_resultado_na_equipe
        )
        this.loadingGrafico = false
      }
      this.loadingGrafico = false
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true

        let populacaoIBGE = await this.$api.get(
          '/app/ultima-atualizacao-dos-dados/' + this.cod_ibge
        )
        if (populacaoIBGE) {
          this.populacaoIbge = populacaoIBGE.data.populacaoIBGE
          let relatorio = await this.$api.get(
            '/app/relatorio-quadrimestral/' + this.cod_ibge
          )
          if (relatorio) {
            this.totalCadastrosMunicipio =
              relatorio.data.total_cadastros_municipio
            this.diferenca_no_municipio =
              relatorio.data.total_cadastros_municipio - this.populacaoIbge
            this.resultado_no_municipio =
              (relatorio.data.total_cadastros_municipio / this.populacaoIbge) *
              100

            let response = await this.$api.get(
              '/app/indicadores-aps/resultado/' +
                this.cod_ibge +
                '/[0,27,28,29]'
            )
            if (response) {
              this.tabelaResultado = response.data
              // dados da série histórica
              let response2 = await this.$api.get(
                `/app/serie-historica/${this.cod_ibge}/indicador/[0,27,28,29]`
              )
              this.dadosSerieHistorica = response2.data
              // dados do município
              this.setarResultadoMunicipio()
              // dados do mapa
              // this.buscarDadosDoMapa()
              this.loading = false
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    async buscarDados(profissional) {
      try {
        this.secretaria_municipal_de_saude_no_acs_atualizados = 0
        this.secretaria_municipal_de_saude_no_acs_desatualizados = 0
        this.secretaria_municipal_de_saude_total_no_acs = 0
        this.loading = true
        this.nomeProfissional = profissional.no_profissional
        let cadastros_individuais = await this.$api.post(
          '/app/cadastros-individuais',
          {
            co_ibge: profissional.co_ibge,
            cpf: profissional.nu_cpf,
          }
        )
        if (cadastros_individuais) {
          this.cadastros = []
          this.cadastros = cadastros_individuais.data
          this.cadastrosOriginais = cadastros_individuais.data
          this.total_de_registros_da_tabela = cadastros_individuais.data.length
          this.secretaria_municipal_de_saude_total_no_acs =
            cadastros_individuais.data.length
          if (this.tabelaResultado) {
            // dados do acs
            this.setarResultadoAcs()
            this.loading = false
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async buscarCadastrosIndividuais(nu_cpf) {
      this.loading = true
      let response = await Functions.getCadastrosIndividuais(
        this.cod_ibge,
        nu_cpf
      )
      if (response) {
        this.cadastros = response
        this.cadastrosOriginais = response
        this.total_de_registros_da_tabela = response.length
        this.loading = false
      }
    },

    async buscarCadastrosIndividuaisTodosPorEquipe() {
      this.loading = true
      let response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
        this.cod_ibge,
        this.equipe.nu_ine
      )
      if (response) {
        this.cadastros = response
        this.cadastrosOriginais = response
        this.total_de_registros_da_tabela = response.length
        this.loading = false
      }
    },

    async buscarUltimaAtualizacao() {
      let response = await Functions.getUltimaAtualizacao(this.cod_ibge)
      if (response) {
        this.data_secretaria_de_saude = this.formatDate(
          response.data_sincronizacao
        )
        this.data_ministerio_da_saude = response.quadrimestre
      }
    },

    buscarDadosDoMapa() {
      // todas as equipes
      // this.dadosDoMapaOriginal = this.tabelaResultado.filter((item) => {
      //   return item.indicador == '0' && item.latitude !== null
      // })
      // Apenas a equipe selecionada
      if (this.equipe != '') {
        this.dadosDoMapaOriginal = this.tabelaResultado.filter((item) => {
          return (
            item.indicador == '0' &&
            item.latitude !== null &&
            item.ibge_ine == this.equipe.nu_ine
          )
        })
      }
      this.$refs.componentMapa.buscarDadosDoMapa()
    },

    carregarSerieHistorica(
      secretaria_municipal_de_saude_resultado_no_municipio,
      indicador
    ) {
      const data = Functions.serieHistoricaMunicipio(
        this.dadosSerieHistorica,
        indicador
      )
      this.$refs.chartData.updateOptions({
        xaxis: {
          categories: data.array_xaxis,
        },
      })
      this.xaxis = data.array_xaxis
      this.$refs.chartData.updateSeries([
        {
          name: 'Município',
          data: data.array_chart_municipio,
        },
      ])
      this.$refs.chartData.updateOptions({
        annotations: {
          yaxis: [
            {
              y: 70,
              y2: secretaria_municipal_de_saude_resultado_no_municipio,
              borderColor: '',
              fillColor: '#b3ffb3',
              label: {
                text: '',
              },
            },
            {
              y: 0,
              y2: 69,
              borderColor: '',
              fillColor: '#ffcccc',
              label: {
                text: '',
              },
            },
          ],
        },
      })
      this.arrayChartMunicipio = data.array_chart_municipio
      this.data_dados_chart = data.data_dados_chart
    },

    carregarSerieHistoricaPorEquipe(
      nu_ine,
      secretaria_municipal_de_saude_resultado_no_municipio,
      secretaria_municipal_de_saude_resultado_na_equipe
    ) {
      let array_chart_equipe = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = this.dadosSerieHistorica
        if (this.indicadorGrafico !== null) {
          dataItens = dataItens.filter((item) => {
            return (
              item.indicador == this.indicadorGrafico.value &&
              item.ibge_ine == nu_ine
            )
          })
        }
        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = item.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_equipe.push(resultado)
      }
      this.arrayChartEquipe = array_chart_equipe
      this.$refs.chartData.updateSeries([
        {
          name: 'MUNICÍPIO',
          data: this.arrayChartMunicipio,
        },
        {
          name: this.nomeEquipe,
          data: array_chart_equipe,
        },
      ])
      this.$refs.chartData.updateOptions({
        annotations: {
          yaxis: [
            {
              y: 70,
              y2:
                secretaria_municipal_de_saude_resultado_no_municipio >
                secretaria_municipal_de_saude_resultado_na_equipe
                  ? secretaria_municipal_de_saude_resultado_no_municipio
                  : secretaria_municipal_de_saude_resultado_na_equipe,
              borderColor: '',
              fillColor: '#b3ffb3',
              label: {
                text: '',
              },
            },
            {
              y: 0,
              y2: 69,
              borderColor: '',
              fillColor: '#ffcccc',
              label: {
                text: '',
              },
            },
          ],
        },
      })
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional,
        this.data_secretaria_de_saude
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarUltimaAtualizacao()
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.green {
  color: green;
}
.red {
  color: red;
}
.orange {
  color: orange;
}

@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}

.map-radius {
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #fff;
  font-weight: 700;
}
</style>
<style scoped>
.filter-table .filter-table-item .input-idade {
  flex-wrap: nowrap;
}
</style>
<style src="./styles.scss" scoped lang="scss" />
